{
  "score": {
    "trustScore": 4.3,
    "stars": 4.5
  },
  "numberOfReviews": 136,
  "profileUrl": "https://www.trustpilot.com/review/petprotect.de",
  "reviews": {
    "de": [
      {
        "id": "69a1911543eb9e6e41fb9fa4",
        "stars": 4,
        "title": "Gute Führung durch den Angebotsprozess",
        "text": "Gute Führung durch den Angebotsprozess, allerdings war das Angebot dann nicht herunterladbar und sollte angeblich per EMail verschickt werden. Dennoch muss man anhaken, dass man das Angebot gelesen hat, obwohl man es nicht lesen kann. Das ist natürlich nicht rechtens.",
        "consumer": "Dr. JUF Buschmann",
        "createdAt": "2026-02-27T14:41:57Z",
        "isVerified": false
      },
      {
        "id": "69611d65a11951881c6f2512",
        "stars": 5,
        "title": "schnell am pc von zuhause",
        "text": "schnell am pc von zuhause",
        "consumer": "Maxi",
        "createdAt": "2026-01-09T17:23:17Z",
        "isVerified": true
      },
      {
        "id": "693ff6337cbb8eac61f5eb2a",
        "stars": 5,
        "title": "komplikationsloser Abschluss",
        "text": "problemloser Versicherungsabschluss",
        "consumer": "Norbert Dingemann",
        "createdAt": "2025-12-15T13:51:15Z",
        "isVerified": true
      },
      {
        "id": "692166f8f550fc2f3747cb21",
        "stars": 5,
        "title": "gute leistung zu fairem preis",
        "text": "gute leistung zu fairem preis",
        "consumer": "Fuhrunternehmen Gantke",
        "createdAt": "2025-11-22T09:32:08Z",
        "isVerified": true
      },
      {
        "id": "68f0af4c8cd5c808f25738ce",
        "stars": 5,
        "title": "Einfachheit",
        "text": "Einfache Menüführung und ab dem Tag versichert.",
        "consumer": "Christian Forget",
        "createdAt": "2025-10-16T10:39:40Z",
        "isVerified": true
      },
      {
        "id": "68ef8058d64020cf7e0dd04d",
        "stars": 5,
        "title": "Ganz einfacher Abschluß",
        "text": "Ganz einfacher Abschluß",
        "consumer": "Stephan Linke",
        "createdAt": "2025-10-15T13:07:04Z",
        "isVerified": true
      },
      {
        "id": "68d9562eb2ad4977a004c741",
        "stars": 4,
        "title": "Keine Altersbegrenzung/bessere Leistungen",
        "text": "Es ist absolut von Vorteil dass es keine Altersbegrenzung gibt. Schon der TOP-Tarif bietet wesentlich bessere Leistungen für nur einen geringen Mehrbeitrag (okay, jetzt mit einer Selbstbeteiligung von € 250,00) zu dem Beitrag vom letzten Jahr meiner alten Versicherung, welche den Beitrag zur nächsten Fälligkeit verdoppelt hat. ",
        "consumer": "Langner Silvia",
        "createdAt": "2025-09-28T17:37:18Z",
        "isVerified": true
      },
      {
        "id": "68be0f811f6f78baae287326",
        "stars": 5,
        "title": "Abwicklung ging sehr schnell",
        "text": "Abwicklung ging sehr schnell",
        "consumer": "Renate",
        "createdAt": "2025-09-08T01:04:33Z",
        "isVerified": true
      },
      {
        "id": "68bd30ed72e2e84c42793fd0",
        "stars": 5,
        "title": "Hat Online alles problemlos funktioniert",
        "text": "Hat Online alles problemlos funktioniert ",
        "consumer": "Ire Er",
        "createdAt": "2025-09-07T09:14:53Z",
        "isVerified": true
      },
      {
        "id": "68bad4d058094313efc124d3",
        "stars": 5,
        "title": "Sehr freundliche ausführliche Beratung.",
        "text": "Sehr freundliche ausführliche Beratung. ",
        "consumer": "Barbara Wegmann",
        "createdAt": "2025-09-05T14:17:20Z",
        "isVerified": true
      },
      {
        "id": "68a6d3daef98a9d7864d9c5b",
        "stars": 5,
        "title": "EINFACH, VERSTÄNDLICH UND UNKOMPLIZIERT",
        "text": "SEHR GUTE ERFAHRUNG, EINFACHE UND UNKOMPLIZIERTE HANDHABUNG",
        "consumer": "Christina Reßmeyer",
        "createdAt": "2025-08-21T10:07:54Z",
        "isVerified": true
      },
      {
        "id": "68a6b09a79248066166e9bb1",
        "stars": 5,
        "title": "Einfach",
        "text": "Einfachheit",
        "consumer": "Karin Vibrans",
        "createdAt": "2025-08-21T07:37:31Z",
        "isVerified": true
      },
      {
        "id": "6894b84711776e832347849d",
        "stars": 5,
        "title": "Ein gutes Angebot!",
        "text": "Ein gutes Angebot! Das Prozedere erfolgte reibungslos. Meine einzige Frage wurde sofort und ohne lange Warteschleife beantwortet.",
        "consumer": "ANNELORE",
        "createdAt": "2025-08-07T16:29:27Z",
        "isVerified": true
      },
      {
        "id": "6894935acf4c53c57e454e91",
        "stars": 5,
        "title": "Super",
        "text": "Hat gut geklappt",
        "consumer": "Birgit Schäfer",
        "createdAt": "2025-08-07T13:51:55Z",
        "isVerified": true
      },
      {
        "id": "6884009df8302a46cf32b6f3",
        "stars": 4,
        "title": "Es war einfach - nur für Welpen intransparent",
        "text": "Es war einfach -allerdings ist das Versichern eines Welpen aufgrund der irreführenden Fragen nicht transparent.",
        "consumer": "Stephanie Imhof",
        "createdAt": "2025-07-26T00:09:33Z",
        "isVerified": true
      }
    ],
    "en": [
      {
        "id": "669945e47330e184929703fc",
        "stars": 5,
        "title": "Danke good 💯",
        "text": "Danke good 💯",
        "consumer": "Vasile angelin Angelin vasile",
        "createdAt": "2024-07-18T18:42:13Z",
        "isVerified": true
      }
    ]
  },
  "lastUpdatedAt": "2026-03-31T12:33:36.381Z"
}